import { ca } from '@cian/analytics';

export const trackCtaClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DemandCpd',
    action: 'click',
    label: 'top_page_find_realtor',
  });
};
